import * as Type from './actionsTypes';

const setCacheFiltroNsir = filtro => ({ type: Type.FILTRO_CACHE_NSIR, filtro });

export {
  setCacheFiltroNsir,
}
